import React from 'react';
import moment from 'moment';
import {Text} from 'components/tt-forms/common';
import {RowItemDocumentDetail} from 'modules/reception/datatable/detail';
import DataTable from 'components/data-table';
import { header } from "constants/table";
import { Link } from 'react-router';
import { ShowIf } from 'components/utils';
import fileDownload from 'js-file-download';
import { checkServerLive } from 'constants/config';
import {downloadFile} from 'components/utils';

class ThongTinNguoiUyQuyen extends React.Component {

  render() {
    return (
      <div className="box-forward">

          <div className="title">
            <div className="rows">
              <div className="col-12">
                <h3>Thông tin người được ủy quyền</h3>
              </div>
            </div>
          </div>
          <div className="group-box">
            <div className="items-form">
              <div className="rows mb10">
                <Text className="col-input" label="Họ và tên:" value={this.props.nguoiDuocUyQuyen.hoVaTen || ''}/>
                <Text className="col-input" label="Ngày sinh:" value={this.props.nguoiDuocUyQuyen.ngaySinh ? moment(this.props.nguoiDuocUyQuyen.ngaySinh).format("DD/MM/YYYY") : ''}/>
                <Text className="col-input" label="Số điện thoại:" value={this.props.nguoiDuocUyQuyen.soDienThoai || ''}/>
                <Text className="col-input" label="Giới tính:" value={this.props.nguoiDuocUyQuyen.gioiTinh ? 'Nam' : "Nữ"}/>
              </div>
            </div>
            <div className="items-form">
              <div className="rows mb10">
                <Text className="col-input" label="Số CMND/ Hộ chiếu:" value={this.props.nguoiDuocUyQuyen.soCMNDHoChieu || ''}/>
                <Text className="col-input" label="Ngày cấp:" value={this.props.nguoiDuocUyQuyen.ngayCap ? moment(this.props.nguoiDuocUyQuyen.ngayCap).format("DD/MM/YYYY") : ''}/>
                <Text className="col-input" label="Nơi cấp:" value={this.props.nguoiDuocUyQuyen.noiCapCMNDInfo ? this.props.nguoiDuocUyQuyen.noiCapCMNDInfo.ten : ''}/>
                <Text className="col-input" label="Quốc tịch:" value={this.props.nguoiDuocUyQuyen.quocTichCongDan ? this.props.nguoiDuocUyQuyen.quocTichCongDan.ten : ''}/>
                <Text className="col-input" label="Dân tộc:" value={this.props.nguoiDuocUyQuyen.danTocCongDan ? this.props.nguoiDuocUyQuyen.danTocCongDan.ten : ''}/>
              </div>
            </div>
            <div className="items-form">
              <div className="rows mb10">
                <Text className="col-input" label="Tỉnh:" value={this.props.nguoiDuocUyQuyen.tinhThanhCongDan ? this.props.nguoiDuocUyQuyen.tinhThanhCongDan.ten : ''}/>
                <Text className="col-input" label="Quận/Huyện:" value={this.props.nguoiDuocUyQuyen.quanHuyenCongDan ? this.props.nguoiDuocUyQuyen.quanHuyenCongDan.ten : ''}/>
                <Text className="col-input" label="Phường/Xã:" value={this.props.nguoiDuocUyQuyen.phuongXaCongDan ? this.props.nguoiDuocUyQuyen.phuongXaCongDan.ten : ''}/>
                <Text className="col-w40" label="Địa chỉ:" value={this.props.nguoiDuocUyQuyen.diaChi || ''}/>
              </div>
            </div>
            <ShowIf condition={this.props.listTepUyQuyen && this.props.listTepUyQuyen.length > 0}>
              <div className="items-form">
                <div className="rows mb10">
                  <div className="col-12">
                    <label className="pt-label mb5">
                      <span className="val-title-bold">Giấy ủy quyền: </span>
                    </label>
                    {
                      this.props.listTepUyQuyen.map((item,i) => {
                        return (
                          <p className="info-document mb5" key={i}>
                            <ShowIf condition={!checkServerLive}>
                              <Link onClick={fileDownload.bind(this, item.urlFile, item.tenFile)} className="name_upload text-13 txt-blue">{item.tenFile}</Link>
                            </ShowIf>
                            <ShowIf condition={checkServerLive}>
                              <Link onClick={()=>{downloadFile(item.urlFile, item.tenFile)}} className="name_upload text-13 txt-blue">{item.tenFile}</Link>
                            </ShowIf>
                          </p>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.nguoiDuocUyQuyen.luatSu}>
              <div className="items-form title mb15">
                <div className="rows">
                  <div className="col-input">
                    <label className="pt-label">
                      <h3>Luật sư</h3>
                    </label>
                  </div>
                </div>
                <div className="rows mb10">
                  <Text className="col-input" label="Số thẻ:" value={this.props.nguoiDuocUyQuyen.soTheLuatSu}/>
                  <Text className="col-input" label="Ngày cấp:" value={this.props.nguoiDuocUyQuyen.ngayCapTheLuatSu ? moment(this.props.nguoiDuocUyQuyen.ngayCapTheLuatSu).format('DD/MM/YYYY') : ''}/>
                  <Text className="col-input" label="Nơi cấp:" value={this.props.nguoiDuocUyQuyen.noiCapTheLuatSu}/>
                  <Text className="col-input" label="Thông tin giới thiệu:" value={this.props.nguoiDuocUyQuyen.thongTinGioiThieu}/>
                </div>
                {
                  this.props.checkTDGS === false &&
                  <div>
                    <div className="title">
                      <div className="rows">
                        <div className="col-12">
                          <h3>Danh sách tài liệu kèm theo</h3>
                        </div>
                      </div>
                    </div>
                    <div className={'items-form'}>
                      <div className="rows">
                        <div className="col-12">
                          <DataTable
                            header={header.detailReception.proof}
                            dataList={this.props.listTaiLieuBangChungLuatSu}
                            hidePagination={true}>
                            <RowItemDocumentDetail/>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </ShowIf>

            <ShowIf condition={this.props.listTepChungChiHanhNghe && this.props.listTepChungChiHanhNghe.length > 0}>
              <div className="items-form">
                <div className="rows mb10">
                  <div className="col-12">
                    <label className="pt-label mb5">
                      <span className="val-title-bold">Chứng chỉ hành nghề:</span>
                    </label>
                    {
                      this.props.listTepChungChiHanhNghe.map((item, i) => {
                        return (
                          <p className="info-document mb5" key={i}>
                            <ShowIf condition={!checkServerLive}>
                              <Link className="name_upload text-13 txt-blue" onClick={fileDownload.bind(this, item.urlFile, item.tenFile)} >{item.tenFile}</Link>
                            </ShowIf>
                            <ShowIf condition={checkServerLive}>
                              <Link className="name_upload text-13 txt-blue" onClick={()=>{downloadFile(item.urlFile, item.tenFile)}} >{item.tenFile}</Link>
                            </ShowIf>
                          </p>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </ShowIf>
          </div>

      </div>
    )
  }
}

ThongTinNguoiUyQuyen.defaultProps = {
  nguoiDuocUyQuyen : [],
  listTepUyQuyen: [],
  listTepChungChiHanhNghe: [],
  listTaiLieuBangChungLuatSu: []
}

export default ThongTinNguoiUyQuyen;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ThongTinNguoiUyQuyen.jsx